import type { Sort, StorageUnit } from 'store/storageunits/types';
import { SortDirection, SortType } from 'store/storageunits/types';
import { sortByName, sortByRecent } from 'store/storageunits/utils';

const sortDirection = (
  storageUnits: StorageUnit[],
  sortDirection: SortDirection,
) => {
  return sortDirection === SortDirection.ASC
    ? storageUnits
    : storageUnits.reverse();
};

export const sortStorageUnits = (storageUnits: StorageUnit[], sortBy: Sort) => {
  const sortFn =
    sortBy.type === SortType.LAST_MODIFIED ? sortByRecent : sortByName;
  return sortDirection(storageUnits.slice().sort(sortFn), sortBy.direction);
};
